export enum InsertMethod {
    Above,
    Below
}
